import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ChevronRightIcon } from '@tyro/icons';
import { Fragment } from 'react';

interface AncestorBreadcrumbsProps {
  titles: string[];
}

export function AncestorBreadcrumbs({ titles }: AncestorBreadcrumbsProps) {
  if (titles.length === 0) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      sx={{ gap: 0.25, mb: 0.25 }}
    >
      {titles.map((title, index) => (
        <Fragment key={`${index}-${title}`}>
          {index > 0 && (
            <ChevronRightIcon
              sx={{ fontSize: 10, color: 'text.disabled', flexShrink: 0 }}
            />
          )}
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ lineHeight: 1.4 }}
          >
            {title}
          </Typography>
        </Fragment>
      ))}
    </Stack>
  );
}
